<div
  class="bb-logo"
  role="img"
  [attr.aria-label]="ariaLabel"
  [attr.aria-hidden]="ariaLabel ? null : true"
  [ngClass]="{
    'bb-logo--emblem': isEmblem,
    'bb-logo--inverse': isInverse
  }"
></div>
